
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire34b5"];
var parcelRegister = parcelRequire.register;
parcelRegister("26AAR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", function () { return $1888870143809eef$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");

var $lFOXD = parcelRequire("lFOXD");

var $39c3M = parcelRequire("39c3M");

var $as5v9 = parcelRequire("as5v9");

var $03EZb = parcelRequire("03EZb");

var $hij2V = parcelRequire("hij2V");

var $gzPfK = parcelRequire("gzPfK");

var $4gtBF = parcelRequire("4gtBF");

var $a48Mt = parcelRequire("a48Mt");

var $9qBCg = parcelRequire("9qBCg");
function $1888870143809eef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1888870143809eef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1888870143809eef$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1888870143809eef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1888870143809eef$var$getParentStack(labelStack) {
    if (!labelStack || labelStack.length <= 1) return null;
    return labelStack.slice(0, labelStack.length - 1);
}
function $1888870143809eef$var$getSegmentId(labelStack) {
    if (!labelStack) return null;
    var leafLabelStack = labelStack[labelStack.length - 1];
    if ((0, $hij2V.isSegmentLabel)(leafLabelStack)) return leafLabelStack.segmentId;
    var parentStack = $1888870143809eef$var$getParentStack(labelStack);
    if (!parentStack) return null;
    return $1888870143809eef$var$getSegmentId(parentStack);
}
function $1888870143809eef$var$getParentSegmentId(labelStack) {
    return $1888870143809eef$var$getSegmentId($1888870143809eef$var$getParentStack(labelStack));
}
/**
 * Whenever a render happen, all parent segment have timing reported
 * This method tries to reduce that noise
 */ function $1888870143809eef$var$removeCascadingParentTimingReport(reactProfilerTimings) {
    var timingIndex = new Map();
    reactProfilerTimings.forEach(function(timing) {
        var segmentId = $1888870143809eef$var$getSegmentId(timing.labelStack);
        if (segmentId) {
            var _timingIndex$get;
            var timingArray = (_timingIndex$get = timingIndex.get(segmentId)) !== null && _timingIndex$get !== void 0 ? _timingIndex$get : [];
            timingIndex.set(segmentId, timingArray);
            timingArray.push(timing);
        }
    });
    reactProfilerTimings.forEach(function(timing) {
        var parentSegmentId = $1888870143809eef$var$getParentSegmentId(timing.labelStack);
        if (parentSegmentId) {
            var parentTimings = timingIndex.get(parentSegmentId);
            var filteredParentTimings = parentTimings === null || parentTimings === void 0 ? void 0 : parentTimings.filter(function(parentTiming) {
                return !(parentTiming.startTime === timing.startTime && parentTiming.actualDuration === timing.actualDuration);
            });
            if (filteredParentTimings) timingIndex.set(parentSegmentId, filteredParentTimings);
            else timingIndex.delete(parentSegmentId);
        }
    });
    return (0, $lFOXD.default)(timingIndex.values()).flatMap(function(v) {
        return v;
    });
}
function $1888870143809eef$var$transformReactProfilerTimings(reactProfilerTimings) {
    var filtered = $1888870143809eef$var$removeCascadingParentTimingReport(reactProfilerTimings !== null && reactProfilerTimings !== void 0 ? reactProfilerTimings : []);
    var reactProfilerTimingsMap = filtered.reduce(function(result, _ref) {
        var labelStack = _ref.labelStack, startTime = _ref.startTime, commitTime = _ref.commitTime, actualDuration = _ref.actualDuration, type = _ref.type;
        if (labelStack && type !== 'nested-update') {
            var label = labelStack.map(function(ls) {
                return ls.name;
            }).join('/');
            var start = Math.round(startTime);
            var end = Math.round(commitTime);
            var cacheKey = (0, $hij2V.stringifyLabelStackFully)(labelStack);
            var timing = result.get(label) || {
                labelStack: label,
                startTime: start,
                endTime: end,
                mountCount: 0,
                rerenderCount: 1,
                renderDuration: 0
            };
            if (start < timing.startTime) timing.startTime = Math.round(start);
            if (end > timing.endTime) timing.endTime = Math.round(end);
            if (type === 'mount') timing.mountCount += 1;
            if (type === 'update') timing.rerenderCount += 1;
            if ((0, $a48Mt.segmentUnmountCache).has(cacheKey)) {
                timing.unmountCount = (0, $a48Mt.segmentUnmountCache).get(cacheKey) || 0;
                (0, $a48Mt.segmentUnmountCache).delete(cacheKey);
            }
            timing.renderDuration += Math.round(actualDuration);
            result.set(label, timing);
        }
        return result;
    }, new Map());
    return (0, $lFOXD.default)(reactProfilerTimingsMap.values());
}
function $1888870143809eef$var$createPostInteractionLogPayload(_ref2) {
    var _getMostRecentVCRevis, _window$location;
    var lastInteractionFinish = _ref2.lastInteractionFinish, reactProfilerTimings = _ref2.reactProfilerTimings, lastInteractionFinishVCResult = _ref2.lastInteractionFinishVCResult, postInteractionFinishVCResult = _ref2.postInteractionFinishVCResult, postInteractionHoldInfo = _ref2.postInteractionHoldInfo;
    var config = (0, $03EZb.getConfig)();
    if (!config) throw Error('UFO Configuration not provided');
    if (!lastInteractionFinish) return null;
    var ufoName = (0, $hij2V.sanitizeUfoName)(lastInteractionFinish.ufoName);
    var rate = (0, $03EZb.getPostInteractionRate)(ufoName, lastInteractionFinish.type);
    if (!(0, $as5v9.default)(rate)) return null;
    if ((0, $39c3M.fg)('platform_ufo_disable_ufo_names_config')) {
        var _config = (0, $03EZb.getConfig)();
        if (_config !== null && _config !== void 0 && _config.disabledUfoNames && _config !== null && _config !== void 0 && _config.disabledUfoNames.includes(ufoName)) return null;
    }
    var pageVisibilityState = (0, $4gtBF.getPageVisibilityState)(lastInteractionFinish.start, lastInteractionFinish.end);
    if (pageVisibilityState !== 'visible') return null;
    // Align post-interaction-logs closer to UFO event behaviour,
    // e.g. also check for aborted or failed events
    if (lastInteractionFinish.abortReason) return null;
    if (lastInteractionFinish.errors.length > 0) return null;
    var maxEndTimeFromProfiler = reactProfilerTimings && reactProfilerTimings.length > 0 ? Math.max.apply(Math, (0, $lFOXD.default)(reactProfilerTimings.map(function(t) {
        return t.commitTime;
    }))) : lastInteractionFinish.end;
    var revisedEndTime = Math.round(maxEndTimeFromProfiler);
    var revisedTtai = Math.round(maxEndTimeFromProfiler - lastInteractionFinish.start);
    var lastInteractionFinishStart = Math.round(lastInteractionFinish.start);
    var lastInteractionFinishEnd = Math.round(lastInteractionFinish.end);
    var lastInteractionFinishTTAI = Math.round(lastInteractionFinish.end - lastInteractionFinish.start);
    var mostRecentVCRevision = (_getMostRecentVCRevis = (0, $03EZb.getMostRecentVCRevision)(lastInteractionFinish.ufoName)) !== null && _getMostRecentVCRevis !== void 0 ? _getMostRecentVCRevis : (0, $03EZb.DEFAULT_TTVC_REVISION);
    var lastInteractionFinishVC90 = null;
    var lastInteractionFinishVCClean = false;
    var lastInteractionFinishVCRev = lastInteractionFinishVCResult === null || lastInteractionFinishVCResult === void 0 ? void 0 : lastInteractionFinishVCResult['ufo:vc:rev'];
    var lastInteractionFinishRevision = lastInteractionFinishVCRev === null || lastInteractionFinishVCRev === void 0 ? void 0 : lastInteractionFinishVCRev.find(function(_ref3) {
        var revision = _ref3.revision;
        return revision === mostRecentVCRevision;
    });
    if (lastInteractionFinishRevision !== null && lastInteractionFinishRevision !== void 0 && lastInteractionFinishRevision.clean) {
        var _lastInteractionFinis;
        lastInteractionFinishVCClean = true;
        lastInteractionFinishVC90 = (_lastInteractionFinis = lastInteractionFinishRevision['metric:vc90']) !== null && _lastInteractionFinis !== void 0 ? _lastInteractionFinis : null;
    }
    var postInteractionFinishVCRatios = {};
    var postInteractionFinishVCClean = false;
    var revisedVC90 = null;
    var lateMutations = [];
    var postInteractionFinishVCRev = postInteractionFinishVCResult === null || postInteractionFinishVCResult === void 0 ? void 0 : postInteractionFinishVCResult['ufo:vc:rev'];
    var postInteractionFinishRevision = postInteractionFinishVCRev === null || postInteractionFinishVCRev === void 0 ? void 0 : postInteractionFinishVCRev.find(function(_ref4) {
        var revision = _ref4.revision;
        return revision === mostRecentVCRevision;
    });
    if (postInteractionFinishRevision !== null && postInteractionFinishRevision !== void 0 && postInteractionFinishRevision.clean) {
        postInteractionFinishVCClean = true;
        postInteractionFinishVCRatios = postInteractionFinishRevision.ratios;
        if (typeof lastInteractionFinishVC90 === 'number') {
            var _postInteractionFinis;
            revisedVC90 = (_postInteractionFinis = postInteractionFinishRevision['metric:vc90']) !== null && _postInteractionFinis !== void 0 ? _postInteractionFinis : null;
        }
        var vcDetails = postInteractionFinishRevision.vcDetails;
        var labelStacks = postInteractionFinishRevision.labelStacks;
        if (vcDetails) lateMutations = (0, $9qBCg.default)(vcDetails, labelStacks, lastInteractionFinish, postInteractionFinishVCRatios);
    }
    return {
        actionSubject: 'experience',
        action: 'measured',
        eventType: 'operational',
        source: 'measured',
        tags: [
            'observability'
        ],
        attributes: {
            properties: {
                // basic
                'event:hostname': ((_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || 'unknown',
                'event:product': config.product,
                'event:schema': '1.0.0',
                'event:source': {
                    name: 'react-ufo/web',
                    version: (0, $gzPfK.getReactUFOPayloadVersion)(lastInteractionFinish.type, true) // always 1.0.1 as `reactProfileTimings` has `labelStack` as an array
                },
                'event:region': config.region || 'unknown',
                'experience:key': 'custom.post-interaction-logs',
                postInteractionLog: {
                    lastInteractionFinish: $1888870143809eef$var$_objectSpread($1888870143809eef$var$_objectSpread({}, lastInteractionFinish), {}, {
                        ufoName: ufoName,
                        start: lastInteractionFinishStart,
                        end: lastInteractionFinishEnd,
                        ttai: lastInteractionFinishTTAI,
                        vc90: lastInteractionFinishVC90,
                        vcClean: lastInteractionFinishVCClean
                    }),
                    revisedEndTime: revisedEndTime,
                    revisedTtai: revisedTtai,
                    revisedVC90: revisedVC90,
                    vcClean: postInteractionFinishVCClean,
                    lateMutations: lateMutations,
                    reactProfilerTimings: $1888870143809eef$var$transformReactProfilerTimings(reactProfilerTimings),
                    postInteractionHoldInfo: postInteractionHoldInfo === null || postInteractionHoldInfo === void 0 ? void 0 : postInteractionHoldInfo.map(function(hold) {
                        return $1888870143809eef$var$_objectSpread($1888870143809eef$var$_objectSpread({}, hold), {}, {
                            labelStack: hold.labelStack.map(function(label) {
                                return label.name;
                            }).join('/')
                        });
                    })
                }
            }
        }
    };
}
var $1888870143809eef$export$2e2bcd8739ae039 = $1888870143809eef$var$createPostInteractionLogPayload;

});
parcelRegister("gzPfK", function(module, exports) {
$parcel$export(module.exports, "LATEST_REACT_UFO_PAYLOAD_VERSION", function () { return $c117ac018a6e5bfd$export$e919e900fc2d7fe8; });
$parcel$export(module.exports, "getReactUFOPayloadVersion", function () { return $c117ac018a6e5bfd$export$159168550e7449b8; });
var $c117ac018a6e5bfd$export$e919e900fc2d7fe8 = '2.0.0';
function $c117ac018a6e5bfd$export$159168550e7449b8(interactionType, isPostInteractionLog) {
    if (isPostInteractionLog) return '1.0.1';
    if (interactionType !== 'page_load' && interactionType !== 'transition') return '1.0.1';
    return $c117ac018a6e5bfd$export$e919e900fc2d7fe8;
}

});

parcelRegister("9qBCg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6dd3b88b3e446084$export$2e2bcd8739ae039; });
function $6dd3b88b3e446084$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $6dd3b88b3e446084$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $6dd3b88b3e446084$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $6dd3b88b3e446084$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $6dd3b88b3e446084$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $6dd3b88b3e446084$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $6dd3b88b3e446084$var$getLateMutations(vcDetails) {
    var labelStacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var lastInteractionFinish = arguments.length > 2 ? arguments[2] : undefined;
    var postInteractionFinishVCRatios = arguments.length > 3 ? arguments[3] : undefined;
    // Map to track which elements are already seen for each timestamp
    var seen = new Map();
    var result = [];
    for(var part in vcDetails){
        var details = vcDetails[part];
        if (!(details !== null && details !== void 0 && details.t) || details.t <= lastInteractionFinish.end || !details.e) continue; // Skip if not late or no elements
        if (!seen.has(details.t)) seen.set(details.t, new Set());
        var seenElements = seen.get(details.t);
        var _iterator = $6dd3b88b3e446084$var$_createForOfIteratorHelper(details.e), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var element = _step.value;
                if (seenElements.has(element)) continue;
                seenElements.add(element);
                var lateMutation = {
                    time: details.t,
                    element: element,
                    viewportHeatmapPercentage: (postInteractionFinishVCRatios === null || postInteractionFinishVCRatios === void 0 ? void 0 : postInteractionFinishVCRatios[element]) || 0
                };
                if (labelStacks) {
                    var labels = labelStacks[element];
                    if (labels && typeof labels !== 'string') {
                        lateMutation.segment = labels.segment;
                        lateMutation.labelStack = labels.labelStack;
                    }
                }
                result.push(lateMutation);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    return result;
}
var $6dd3b88b3e446084$export$2e2bcd8739ae039 = $6dd3b88b3e446084$var$getLateMutations;

});



//# sourceMappingURL=create-post-interaction-log-payload.615ba147.js.map
